/* eslint-disable import/first */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Breadcrumbs } from "@mui/material";
import styled from "styled-components";
export var CustomBreadcrumbs = styled(Breadcrumbs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font: normal normal normal 12px Roboto;\n  }\n"], ["\n  && {\n    font: normal normal normal 12px Roboto;\n  }\n"])));
var templateObject_1;
